<template>
  <div class="fidelity-campaign-resume">
    <v-list three-line>
      <template v-for="(section, idx) in dataContent">
        <div :key="idx" v-if="section.data">
          <v-divider />
          <v-subheader>{{ section.title }}</v-subheader>
          <v-divider />

          <div class="resume-list">
            <template v-for="(column, idx) in section.columns">
              <v-list-tile :key="idx" v-if="section.data[column.key]" :class="column.class" >
                <v-list-tile-content>
                  <v-list-tile-title class="primary--text">{{ column.label }}</v-list-tile-title>
                  <v-list-tile-sub-title v-if="!column.type">
                    {{ (column.formatter && column.formatter(section.data)) || section.data[column.key] }}
                  </v-list-tile-sub-title>
                  <div v-else-if="column.type === 'file'" class="file-column-container">
                    <object
                      v-if="section.data[column.key]"
                      :data="`${section.data[column.key]}#toolbar=0&navpanes=0&scrollbar=0`"
                      type="application/pdf"
                      height="320"
                      frameborder="0"
                    ></object>
                  </div>
                  <div v-else-if="column.type === 'html'">
                    <div v-html="section.data[column.key]" class="html-column-container"></div>
                  </div>
                  <div v-else-if="column.type === 'list'">
                    <div class="list-column-container">
                      <div 
                        class="list-column-item" 
                        v-for="(item, index) in section.data[column.key]" 
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div class="table-column-container" v-else-if="column.type === 'table'">
                    <v-data-table
                      :headers="column.headers"
                      :items="section.data[column.key]"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.quantity }}</td>
                        <td>{{ props.item.value }}</td>
                      </template>
                    </v-data-table>
                  </div>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </div>
        </div>
      </template>
    </v-list>

    <div v-if="showActions" class="stepper-footer">
      <v-btn color="secondary" @click="back">Voltar</v-btn>
      <v-btn color="primary" @click="save">Salvar</v-btn>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import {
  campaignPremiumTypes,
  discountType,
  premiumTypes
} from "@/views/partners/fidelityCampaign/fidelityCampaignModels";
import AppFileInput from "@/components/ui/inputs/AppFileInput";

function keyValueFormatter(data, mapper) {
  return mapper[data];
}

export default {
  name: "FidelityCampaignResume",
  components: {AppFileInput},
  props: {
    resume: Object,
    showActions: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      dataContent: []
    }
  },

  computed: {
    ...mapGetters(['getUser']),
    isAdmin() {
      const { container } = this.getUser
      return container === 'app'
    }
  },

  mounted() {

    const { general, partner, premium } = this.resume;

    this.dataContent = [
      {
        title: 'Participantes',
        data: partner,
        columns: [
          { key: 'partnerName', label: 'Parceiro' },
          { key: 'subscriptionType', label: 'Tipo de inscrição' },
          { key: 'subscription', label: 'Participantes' },
          { key: 'isAllCompanies', label: 'Todas as empresas' },
          { key: 'selectedCompanies', label: 'Empresas selecionadas', type: 'list', class: 'list-column' }
          // { key: 'participantSegmentation', label: 'Segmentação de participantes' },
          // { key: 'registrationRoutine', label: 'Rotina de inscrição' }
        ]
      },
      {
        title: 'Dados Gerais e Metas',
        data: general,
        columns: [
          { key: 'rules', label: 'Regulamento', type: 'file', class: 'file-column' },
          { key: 'statusDescription', label: 'Situação'},
          { key: 'name', label: 'Nome' },
          { key: 'description', label: 'Descrição', class: 'description-column' },
          { key: 'tasks', label: 'Tarefas' , type: 'html', class: 'html-column' },
          { key: 'period', label: 'Período' },
          { key: 'platforms', label: 'Disponibilizar campanha nas plataformas' },
          { key: 'reminder', label: 'Tempo para aviso de encerramento (dias)' },
          { key: 'goalType', label: 'Qual meta os participantes devem atingir?'},
          { key: 'goal', label: 'Valor mínimo'}
        ]
      },
      {
        title: 'Premiação',
        data: premium,
        columns: [
          { key: 'products', label: 'Produtos' },
          {
            key: 'premiumType',
            label: 'Tipo de premiação',
            formatter: (row) => keyValueFormatter(row.premiumType, premiumTypes)
          },
          {
            key: 'type',
            label: 'Premiação',
            formatter: (row) => keyValueFormatter(row.premiumType, campaignPremiumTypes)
          },
          { key: 'usersLimit', label: 'Limite de ganhadores' },
          { key: 'maxUsersPremiums', label: 'Máximo de prêmios por participante' },
          {
            key: 'discountType',
            label: 'Tipo de desconto',
            formatter: (row) => keyValueFormatter(row.discountType, discountType)
          },
          { key: 'premiumInfo', label: 'Prêmio' },
          { key: 'provideBalance', label: 'Provisionar Saldo' },
          { key: 'balanceProvisioning', label: 'Saldo Provisionado' },
          {
            key: 'progressiveDiscount',
            label: 'Desconto',
            type: 'table',
            class: 'table-column',
            headers: [
              {text: 'Quantidade', value: 'quantity', sortable: false},
              {text: 'Desconto', value: 'value', sortable: false},
            ]
          },
        ]
      }
    ]
  },

  methods: {
    back() {
      this.$emit('back');
    },
    save() {
      this.$emit('submit');
    }
  }
}
</script>

<style lang="stylus">
  .fidelity-campaign-resume {
    .resume-list {
      display: grid;
      grid-template-columns: 1fr 1fr;

      .file-column {
        padding-top: 12px;
        grid-column: 2;
        grid-row: 1/5;

        .v-list__tile.theme--light {
          height: auto;
        }

        &-container {
          padding-top: 4px;
          width: 100%;
          display: grid;
          justify-items: stretch;
        }
      }

      .description-column {
        .v-list__tile {
          height: 140px;
        }
      }

      .table-column {
        padding-top: 12px;
        grid-column: 1;
        grid-row: 1/3;

        .v-list__tile.theme--light {
          height: auto;
        }

        &-container {
          width: 100%;
        }

      }

      .html-column {
        padding-top: 12px;
        grid-column: 1;

        .v-list__tile.theme--light {
          height: auto;
        }

        .v-list__tile__content {
          max-width: 700px;
          .v-list__tile__title {
            font-size: 16px;
          }

          div:nth-of-type(2) {
            max-height: 200px;
            overflow-y: auto;
            width: 100%;
            padding-top: 0.2rem;
          }
        }
      }

      .list-column {
        padding-top: 12px;
        grid-column: 2;
        grid-row: 1;
        max-height: 120px;

        .v-list__tile.theme--light {
          height: auto;
        }

        .v-list__tile__title {
          font-size: 16px;
        }

        &-container {
          padding-top: 4px;
          width: 100%;
          display: grid;
          justify-items: stretch;
          max-height: 90px;
          overflow-y: auto;
          min-width: 500px;
        }

        &-item {
          padding: 0.1rem 0;
        }
        
      }

      .list-column, .html-column {
        color: rgba(0,0,0,.54);
        
        .v-list__tile__content {
          font-size: 14px;
        }
      }

    }

    .v-subheader {
      background-color: var(--v-primary-base);
      color: white;
    }
  }
</style>
